/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { userInfoSchema } from "./userInfoSchema.ts";
import { z } from "zod";

export const userSchema = z.lazy(() => userInfoSchema).and(z.object({
      "id": z.string(),
  "username": z.string().describe("Nom d'utilisateur").optional(),
  "websiteUrl": z.string().describe("URL du site web de l'utilisateur").optional()
      }))